import { createPortal } from 'react-dom';
import { Loader2 } from 'lucide-react';
import type { GalleryItem } from '@/features/gallery/types/gallery';

type DeleteConfirmModalProps = {
  item: GalleryItem | null;
  isDeleting: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export function DeleteConfirmModal({ item, isDeleting, onCancel, onConfirm }: DeleteConfirmModalProps) {
  if (!item) return null;

  return createPortal(
    <div className="fixed inset-0 z-[90] flex items-center justify-center p-4">
      <button
        type="button"
        aria-label="Close overlay"
        className="absolute inset-0 bg-black/40"
        onClick={onCancel}
      />
      <div className="relative z-10 w-full max-w-md rounded-3xl border border-[var(--dash-line)] bg-white p-5 text-left shadow-2xl">
        <h3 className="m-0 text-lg font-semibold text-[var(--dash-ink)]">Delete content</h3>
        <p className="mt-2 mb-0 text-sm leading-relaxed text-[var(--dash-muted)]">
          You will lose “{item.contentName || 'this content'}”
          permanently. Are you sure?
        </p>
        <div className="mt-5 flex justify-end gap-2">
          <button
            type="button"
            disabled={isDeleting}
            onClick={onCancel}
            className="rounded-xl border border-[var(--dash-line)] bg-white px-4 py-2.5 text-sm font-semibold text-[var(--dash-ink)]"
          >
            Cancel
          </button>
          <button
            type="button"
            disabled={isDeleting}
            onClick={onConfirm}
            className="inline-flex min-w-[120px] items-center justify-center gap-2 rounded-xl bg-red-600 px-4 py-2.5 text-sm font-semibold text-white disabled:opacity-60"
          >
            {isDeleting ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Delete'}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
